import { render, staticRenderFns } from "./TabModeratorStudentActivity.vue?vue&type=template&id=348d4663&"
import script from "./TabModeratorStudentActivity.vue?vue&type=script&lang=js&"
export * from "./TabModeratorStudentActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports